import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-6 grid grid-cols-12 gap-y-8 gap-4" }
const _hoisted_2 = { class: "col-span-12 sm:col-span-6 lg:col-span-8" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-y-6 gap-3" }
const _hoisted_4 = { class: "col-span-12 sm:col-span-6 lg:col-span-4" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-y-6 gap-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "col-span-12 border-b border-gray-100" }, null, -1)
const _hoisted_7 = { class: "col-span-12 sm:col-span-6 space-y-6" }
const _hoisted_8 = { class: "col-span-12 sm:col-span-6 space-y-6" }
const _hoisted_9 = { class: "flex-shrink-0 inline-block" }

import {
  MedKitButton,
  MedKitDateTimeField,
  MedKitFieldLabel,
  MedKitNumberField,
  MedKitRadioGroup,
  MedKitSearch,
  MedKitSelect,
  MedKitTextField,
  MedKitSwitch,
} from '@bigpicturemedical/medkit'
import {
  DvBoolean,
  DvCodedText,
  DvCodedTextFilter,
  TerminologySearch,
  DvCodedTextList,
  DvDateTime,
  DvDuration,
  DvQuantity,
  DvText,
  NodeRepeater,
  IPath,
  useWebTemplateHelpers
} from '@bigpicturemedical/openehr-vue'
import { PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { BlockPanelHeader, BlockHeader, BlockPanel, BlockContainer } from './_layout'


export default /*#__PURE__*/_defineComponent({
  __name: 'MedicationsBlock',
  props: {
  path: {
    type: Object as PropType<IPath>,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  errors: {
    type: Array as PropType<Array<string>>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;



const { getData } = useWebTemplateHelpers()
const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BlockContainer), { class: "space-y-6" }, {
    default: _withCtx(() => [
      _createVNode(_unref(BlockHeader), {
        heading: __props.name,
        description: __props.description
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DvCodedText), {
            path: props.path.add('exclusion_-_global.global_exclusion_of_medication_use')
          }, {
            default: _withCtx(({ value, setValue, items }) => [
              _createVNode(_unref(MedKitSwitch), {
                class: "w-max",
                "model-value": !! value,
                label: _unref(t)('medicationsStatement.globalExclusionOfMedicationUse'),
                "label-position": "start",
                contained: "",
                "onUpdate:modelValue": ($event: any) => (setValue($event ? items[0] : undefined))
              }, null, 8, ["model-value", "label", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["path"])
        ]),
        _: 1
      }, 8, ["heading", "description"]),
      _createVNode(_unref(NodeRepeater), {
        path: props.path.add('medication_statement'),
        "present-if": ! _unref(getData)(props.path.add('exclusion_-_global.global_exclusion_of_medication_use')),
        reverse: ""
      }, {
        header: _withCtx(({ addItem }) => [
          _createVNode(_unref(MedKitButton), {
            class: "w-full",
            kind: "repeater",
            label: _unref(t)('medicationsStatement.medications.add'),
            icon: "plus",
            "icon-position": "start",
            onClick: addItem
          }, null, 8, ["label", "onClick"])
        ]),
        default: _withCtx(({ index: medicationStatementIndex, remove }) => [
          _createVNode(_unref(BlockPanel), null, {
            default: _withCtx(() => [
              _createVNode(_unref(BlockPanelHeader), {
                title: _unref(t)('medicationsStatement.medications.title')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(MedKitButton), {
                    size: "small",
                    label: _unref(t)('medicationsStatement.medications.remove'),
                    "icon-position": "only",
                    icon: "delete",
                    onClick: remove
                  }, null, 8, ["label", "onClick"])
                ]),
                _: 2
              }, 1032, ["title"]),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(DvCodedText), {
                      path: props.path.add(`medication_statement.${medicationStatementIndex}.medication_name`)
                    }, {
                      default: _withCtx(({ name: fieldName, terminology, value, setValue, errors: fieldErrors, validate, required }) => [
                        _createVNode(_unref(TerminologySearch), { terminology: terminology }, {
                          default: _withCtx(({ search, searching, results, error: terminologySearchError }) => [
                            _createVNode(_unref(MedKitSearch), {
                              class: "col-span-2",
                              "model-value": value ? { label: value['|value'], value: value } : undefined,
                              error: terminologySearchError ?? fieldErrors[0],
                              label: fieldName,
                              "is-loading": searching,
                              options: results.map(result => ({
                        label: result['|value'],
                        value: result,
                      })),
                              placeholder: _unref(t)('medicationsStatement.medication.medicationName.placeholder'),
                              required: required,
                              "onUpdate:query": search,
                              "onUpdate:modelValue": ($event: any) => (setValue($event ? $event.value : undefined)),
                              onInput: validate
                            }, null, 8, ["model-value", "error", "label", "is-loading", "options", "placeholder", "required", "onUpdate:query", "onUpdate:modelValue", "onInput"])
                          ]),
                          _: 2
                        }, 1032, ["terminology"])
                      ]),
                      _: 2
                    }, 1032, ["path"]),
                    _createVNode(_unref(DvCodedText), {
                      path: props.path.add(`medication_statement.${medicationStatementIndex}.route`)
                    }, {
                      default: _withCtx(({ name: fieldName, terminology, value, setValue, errors: fieldErrors, validate, required }) => [
                        _createVNode(_unref(TerminologySearch), { terminology: terminology }, {
                          default: _withCtx(({ search, searching, results, error: terminologySearchError }) => [
                            _createVNode(_unref(MedKitSearch), {
                              class: "col-span-2 lg:col-span-1",
                              "model-value": value ? { label: value['|value'], value: value } : undefined,
                              error: terminologySearchError ?? fieldErrors[0],
                              label: fieldName,
                              "is-loading": searching,
                              options: results.map(result => ({
                        label: result['|value'],
                        value: result,
                      })),
                              placeholder: _unref(t)('medicationsStatement.medication.route.placeholder'),
                              required: required,
                              "onUpdate:query": search,
                              "onUpdate:modelValue": ($event: any) => (setValue($event ? $event.value : undefined)),
                              onInput: validate
                            }, null, 8, ["model-value", "error", "label", "is-loading", "options", "placeholder", "required", "onUpdate:query", "onUpdate:modelValue", "onInput"])
                          ]),
                          _: 2
                        }, 1032, ["terminology"])
                      ]),
                      _: 2
                    }, 1032, ["path"]),
                    _createVNode(_unref(DvCodedText), {
                      path: props.path.add(`medication_statement.${medicationStatementIndex}.clinical_indication`)
                    }, {
                      default: _withCtx(({ name: fieldName, terminology, value, setValue, errors: fieldErrors, validate, required }) => [
                        _createVNode(_unref(TerminologySearch), { terminology: terminology }, {
                          default: _withCtx(({ search, searching, results, error: terminologySearchError }) => [
                            _createVNode(_unref(MedKitSearch), {
                              class: "col-span-2 lg:col-span-1",
                              "model-value": value ? { label: value['|value'], value: value } : undefined,
                              error: terminologySearchError ?? fieldErrors[0],
                              label: fieldName,
                              "is-loading": searching,
                              options: results.map(result => ({
                        label: result['|value'],
                        value: result,
                      })),
                              placeholder: _unref(t)('medicationsStatement.medication.clinicalIndication.placeholder'),
                              required: required,
                              "onUpdate:query": search,
                              "onUpdate:modelValue": ($event: any) => (setValue($event ? $event.value : undefined)),
                              onInput: validate
                            }, null, 8, ["model-value", "error", "label", "is-loading", "options", "placeholder", "required", "onUpdate:query", "onUpdate:modelValue", "onInput"])
                          ]),
                          _: 2
                        }, 1032, ["terminology"])
                      ]),
                      _: 2
                    }, 1032, ["path"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(DvCodedText), {
                      path: props.path.add(`medication_statement.${medicationStatementIndex}.status`)
                    }, {
                      default: _withCtx(({ name: fieldName, options, selected, setSelected, errors: fieldErrors, validate, required }) => [
                        _createVNode(_unref(MedKitSelect), {
                          class: "col-span-2",
                          error: fieldErrors[0],
                          label: fieldName,
                          "model-value": selected,
                          options: options,
                          required: required,
                          placeholder: _unref(t)('medicationsStatement.medication.status.placeholder'),
                          "onUpdate:modelValue": setSelected,
                          onInput: validate
                        }, null, 8, ["error", "label", "model-value", "options", "required", "placeholder", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 2
                    }, 1032, ["path"]),
                    _createVNode(_unref(DvDateTime), {
                      path: props.path.add(`medication_statement.${medicationStatementIndex}.start_date`)
                    }, {
                      default: _withCtx(({ name: fieldName, value, setValue, errors: fieldErrors, validate, required }) => [
                        _createVNode(_unref(MedKitDateTimeField), {
                          class: _normalizeClass(["col-span-2", [
                      ! ['385658003', '385655000', '410546004'].includes(_unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.status`))?.['|code']) ? 'col-span-2' : 'sm:col-span-1'
                    ]]),
                          error: fieldErrors[0],
                          label: fieldName,
                          "model-value": value,
                          required: required,
                          "date-input-only": "",
                          "onUpdate:modelValue": setValue,
                          onInput: validate
                        }, null, 8, ["class", "error", "label", "model-value", "required", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 2
                    }, 1032, ["path"]),
                    _createVNode(_unref(DvDateTime), {
                      path: props.path.add(`medication_statement.${medicationStatementIndex}.end_date`),
                      "present-if": ['385658003', '385655000', '410546004'].includes(_unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.status`))?.['|code'])
                    }, {
                      default: _withCtx(({ name: fieldName, value, setValue, errors: fieldErrors, validate, required }) => [
                        _createVNode(_unref(MedKitDateTimeField), {
                          class: "col-span-2 sm:col-span-1",
                          error: fieldErrors[0],
                          label: fieldName,
                          "model-value": value,
                          required: required,
                          "date-input-only": "",
                          "onUpdate:modelValue": setValue,
                          onInput: validate
                        }, null, 8, ["error", "label", "model-value", "required", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 2
                    }, 1032, ["path", "present-if"]),
                    _createVNode(_unref(DvCodedText), {
                      path: props.path.add(`medication_statement.${medicationStatementIndex}.status_reason`),
                      "present-if": ['385655000', '410546004'].includes(_unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.status`))?.['|code'])
                    }, {
                      default: _withCtx(({ name: fieldName, options, selected, setSelected, errors: fieldErrors, validate, required }) => [
                        _createVNode(_unref(MedKitSelect), {
                          class: "col-span-2",
                          error: fieldErrors[0],
                          label: fieldName,
                          "model-value": selected,
                          options: options,
                          required: required,
                          placeholder: _unref(t)('medicationsStatement.medication.statusReason.placeholder'),
                          "onUpdate:modelValue": setSelected,
                          onInput: validate
                        }, null, 8, ["error", "label", "model-value", "options", "required", "placeholder", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 2
                    }, 1032, ["path", "present-if"])
                  ])
                ]),
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(DvQuantity), {
                    path: props.path.add(`medication_statement.${medicationStatementIndex}.dosage.dose`)
                  }, {
                    default: _withCtx(({
                  name: fieldName,
                  min,
                  max,
                  magnitude,
                  setMagnitude,
                  validate,
                  validateIfAlreadyValidated,
                  errors: fieldErrors,
                  required: doseRequired
                }) => [
                      _createVNode(_unref(DvCodedText), {
                        path: props.path.add(`medication_statement.${medicationStatementIndex}.dosage.dose_unit`)
                      }, {
                        default: _withCtx(({ options, selected, setSelected, errors: doseUnitErrors, required: doseUnitRequired }) => [
                          _createVNode(_unref(MedKitNumberField), {
                            "model-value": magnitude,
                            unit: selected,
                            label: fieldName,
                            min: min,
                            max: max,
                            "unit-options": options,
                            error: fieldErrors[0] || doseUnitErrors[0],
                            placeholder: _unref(t)('medicationsStatement.medication.doseAmount.placeholder', { units: options.find(option => option.value === selected)?.label || 'unit(s)' }),
                            required: doseRequired || doseUnitRequired,
                            "onUpdate:modelValue": setMagnitude,
                            "onUpdate:unit": setSelected,
                            onInput: validateIfAlreadyValidated,
                            onBlur: validate
                          }, null, 8, ["model-value", "unit", "label", "min", "max", "unit-options", "error", "placeholder", "required", "onUpdate:modelValue", "onUpdate:unit", "onInput", "onBlur"])
                        ]),
                        _: 2
                      }, 1032, ["path"])
                    ]),
                    _: 2
                  }, 1032, ["path"]),
                  _createVNode(_unref(DvText), {
                    path: props.path.add(`medication_statement.${medicationStatementIndex}.dosage.dose_description`)
                  }, {
                    default: _withCtx(({ name: fieldName, value, setValue, errors: fieldErrors, validate, validateIfAlreadyValidated, required }) => [
                      _createVNode(_unref(MedKitTextField), {
                        error: fieldErrors[0],
                        label: fieldName,
                        "model-value": value,
                        multiline: "",
                        placeholder: _unref(t)('medicationsStatement.medication.doseDescription.placeholder'),
                        required: required,
                        "onUpdate:modelValue": setValue,
                        onInput: validateIfAlreadyValidated,
                        onBlur: validate
                      }, null, 8, ["error", "label", "model-value", "placeholder", "required", "onUpdate:modelValue", "onInput", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["path"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_unref(DvCodedText), {
                    path: props.path.add(`medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`)
                  }, {
                    default: _withCtx(({ name: fieldName, options, selected, setSelected, errors: fieldErrors, validate, required }) => [
                      _createVNode(_unref(MedKitRadioGroup), {
                        name: `medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`,
                        error: fieldErrors[0],
                        label: fieldName,
                        "model-value": selected,
                        options: options.map(option => ({
                    label: _unref(t)(`medicationsStatement.medication.isThisTakenDaily.options.${option.value}`),
                    value: option.value,
                  })),
                        contained: "",
                        required: required,
                        "onUpdate:modelValue": setSelected,
                        onInput: validate
                      }, null, 8, ["name", "error", "label", "model-value", "options", "required", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 2
                  }, 1032, ["path"]),
                  _createVNode(_unref(DvQuantity), {
                    path: props.path.add(`medication_statement.${medicationStatementIndex}.timing_-_daily.frequency`),
                    "present-if": _unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`))?.['|code'] === '69620002'
                  }, {
                    default: _withCtx(({
                  name: fieldName,
                  unitOptions,
                  min,
                  max,
                  magnitude,
                  unit,
                  setMagnitude,
                  setUnit,
                  validate,
                  validateIfAlreadyValidated,
                  errors: fieldErrors,
                  required
                }) => [
                      _createVNode(_unref(MedKitNumberField), {
                        "model-value": magnitude,
                        unit: unit,
                        label: fieldName,
                        min: min,
                        max: max,
                        "unit-options": unitOptions.map(option => ({
                    label: _unref(t)(`medicationsStatement.medication.timingDaily.frequency.units.${option.value}`),
                    value: option.value,
                  })),
                        error: fieldErrors[0],
                        placeholder: _unref(t)('medicationsStatement.medication.timingDaily.frequency.placeholder'),
                        required: required,
                        "onUpdate:modelValue": setMagnitude,
                        "onUpdate:unit": setUnit,
                        onInput: validateIfAlreadyValidated,
                        onBlur: validate
                      }, null, 8, ["model-value", "unit", "label", "min", "max", "unit-options", "error", "placeholder", "required", "onUpdate:modelValue", "onUpdate:unit", "onInput", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["path", "present-if"]),
                  _createVNode(_unref(DvText), {
                    path: props.path.add(`medication_statement.${medicationStatementIndex}.timing_-_daily.timing_description`),
                    "present-if": _unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`))?.['|code'] === '69620002'
                  }, {
                    default: _withCtx(({ name: fieldName, value, setValue, errors: fieldErrors, validate, validateIfAlreadyValidated, required }) => [
                      _createVNode(_unref(MedKitTextField), {
                        error: fieldErrors[0],
                        label: fieldName,
                        "model-value": value,
                        multiline: "",
                        placeholder: _unref(t)('medicationsStatement.medication.timingDaily.timingDescription.placeholder'),
                        required: required,
                        "onUpdate:modelValue": setValue,
                        onInput: validateIfAlreadyValidated,
                        onBlur: validate
                      }, null, 8, ["error", "label", "model-value", "placeholder", "required", "onUpdate:modelValue", "onInput", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["path", "present-if"]),
                  _createElementVNode("div", {
                    class: _normalizeClass([ _unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`))?.['|code'] !== '69620002' ? 'hidden' : 'sm:flex sm:space-x-2 space-y-6 sm:space-y-0'])
                  }, [
                    _createVNode(_unref(DvBoolean), {
                      path: props.path.add(`medication_statement.${medicationStatementIndex}.timing_-_daily.as_required`),
                      "present-if": _unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`))?.['|code'] === '69620002'
                    }, {
                      default: _withCtx(({ value, setValue }) => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_unref(MedKitFieldLabel), {
                            for: `medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`,
                            label: "As required"
                          }, null, 8, ["for"]),
                          _createVNode(_unref(MedKitSwitch), {
                            id: `medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`,
                            class: "w-max mt-2",
                            "model-value": !! value,
                            label: _unref(t)('medicationsStatement.medication.timingDaily.asRequired.label'),
                            "label-position": "end",
                            contained: "",
                            "onUpdate:modelValue": setValue
                          }, null, 8, ["id", "model-value", "label", "onUpdate:modelValue"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["path", "present-if"]),
                    _createVNode(_unref(DvText), {
                      path: props.path.add(`medication_statement.${medicationStatementIndex}.timing_-_daily.criterion`),
                      "present-if": _unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`))?.['|code'] === '69620002'
                    }, {
                      default: _withCtx(({
                    name: fieldName,
                    value,
                    setValue,
                    errors: fieldErrors,
                    validate,
                    validateIfAlreadyValidated,
                    required
                  }) => [
                        _createVNode(_unref(MedKitTextField), {
                          class: "flex-1",
                          error: fieldErrors[0],
                          label: fieldName,
                          "model-value": value,
                          placeholder: _unref(t)('medicationsStatement.medication.timingDaily.criterion.placeholder'),
                          required: required,
                          "onUpdate:modelValue": setValue,
                          onInput: validateIfAlreadyValidated,
                          onBlur: validate
                        }, null, 8, ["error", "label", "model-value", "placeholder", "required", "onUpdate:modelValue", "onInput", "onBlur"])
                      ]),
                      _: 2
                    }, 1032, ["path", "present-if"])
                  ], 2),
                  _createVNode(_unref(DvDuration), {
                    path: props.path.add(`medication_statement.${medicationStatementIndex}.timing_-_non-daily.repetition_interval`),
                    "present-if": _unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`))?.['|code'] === '1281000261104'
                  }, {
                    default: _withCtx(({
                  name: fieldName,
                  errors: fieldErrors,
                  validate,
                  validateIfAlreadyValidated,
                  periodOptions,
                  setDuration,
                  setPeriod,
                  duration,
                  period,
                  required
                }) => [
                      _createVNode(_unref(MedKitNumberField), {
                        error: fieldErrors[0],
                        label: fieldName,
                        "model-value": duration,
                        "unit-options": periodOptions.map(option => ({
                    label: _unref(t)(`medicationsStatement.medication.timingNonDaily.repetitionInterval.units.${option.value}`),
                    value: option.value,
                  })),
                        unit: period,
                        placeholder: _unref(t)('medicationsStatement.medication.timingNonDaily.repetitionInterval.placeholder'),
                        required: required,
                        "onUpdate:modelValue": setDuration,
                        "onUpdate:unit": setPeriod,
                        onInput: validateIfAlreadyValidated,
                        onBlur: validate
                      }, null, 8, ["error", "label", "model-value", "unit-options", "unit", "placeholder", "required", "onUpdate:modelValue", "onUpdate:unit", "onInput", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["path", "present-if"]),
                  _createVNode(_unref(DvCodedTextList), {
                    path: props.path.add(`medication_statement.${medicationStatementIndex}.timing_-_non-daily.specific_day_of_week`),
                    "present-if": _unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`))?.['|code'] === '1281000261104'
                  }, {
                    default: _withCtx(({ name: fieldName, values, setValues, items, errors: fieldErrors, validate, required }) => [
                      _createVNode(_unref(DvCodedTextFilter), { items: items }, {
                        default: _withCtx(({ filter, results }) => [
                          _createVNode(_unref(MedKitSearch), {
                            multiple: "",
                            "model-value": values.map(value => ({
                      label: value['|value'],
                      value: value,
                    })),
                            error: fieldErrors[0],
                            label: fieldName,
                            "min-search-length": 1,
                            options: results.map(result => ({
                      label: result['|value'],
                      value: result,
                    })),
                            placeholder: _unref(t)('medicationsStatement.medication.timingNonDaily.specificDayOfWeek.placeholder'),
                            required: required,
                            "onUpdate:query": filter,
                            "onUpdate:modelValue": ($event: any) => (setValues($event.map(value => value.value))),
                            onInput: validate
                          }, null, 8, ["model-value", "error", "label", "options", "placeholder", "required", "onUpdate:query", "onUpdate:modelValue", "onInput"])
                        ]),
                        _: 2
                      }, 1032, ["items"])
                    ]),
                    _: 2
                  }, 1032, ["path", "present-if"]),
                  _createVNode(_unref(DvText), {
                    path: props.path.add(`medication_statement.${medicationStatementIndex}.timing_-_non-daily.timing_description`),
                    "present-if": _unref(getData)(props.path.add(`medication_statement.${medicationStatementIndex}.timing.is_this_taken_daily`))?.['|code'] === '1281000261104'
                  }, {
                    default: _withCtx(({ name: fieldName, value, setValue, errors: fieldErrors, validate, validateIfAlreadyValidated, required }) => [
                      _createVNode(_unref(MedKitTextField), {
                        error: fieldErrors[0],
                        label: fieldName,
                        "model-value": value,
                        multiline: "",
                        placeholder: _unref(t)('medicationsStatement.medication.timingNonDaily.timingDescription.placeholder'),
                        required: required,
                        "onUpdate:modelValue": setValue,
                        onInput: validateIfAlreadyValidated,
                        onBlur: validate
                      }, null, 8, ["error", "label", "model-value", "placeholder", "required", "onUpdate:modelValue", "onInput", "onBlur"])
                    ]),
                    _: 2
                  }, 1032, ["path", "present-if"])
                ])
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["path", "present-if"])
    ]),
    _: 1
  }))
}
}

})